import { useState } from 'react';
import { CreateExportAsyncJobRequest } from '@wix/bex-utils/@wix/ambassador-fedinfra-exportservice-v1-export-async-job/types';
import { BackupFn, BulkUploadItemsFn } from '../state';

export interface UseImportConfigParams {
  fields: CreateExportAsyncJobRequest['fields'];
  bulkUploadItems: BulkUploadItemsFn;
  backup?: BackupFn;
  batchSize?: number;
}

export function useImportConfig(params: UseImportConfigParams) {
  const [config] = useState(() => params);

  return config;
}
